import React from 'react';
import {Checkbox, CheckboxGroup, Fieldset, For} from "@chakra-ui/react";
import {Field} from "@/components";

export const CheckboxView = ({choices, label, conditional, required, onChange, ...props}) => {

    return (
        <Field
            label={`${label}${required ? '*' : ''} :`}
            {...props}
        >
            <Fieldset.Root>
                <CheckboxGroup
                    name={`checkboxes-${label}`}
                    alignSelf="flex-start"
                    value={[]}
                    onValueChange={onChange}
                >
                    <Fieldset.Content>
                        <For each={choices}>
                            {(value, i) => (
                                <Checkbox.Root key={`checkbox-${i}`} value={value}>
                                    <Checkbox.HiddenInput/>
                                    <Checkbox.Control/>
                                    <Checkbox.Label>{value}</Checkbox.Label>
                                </Checkbox.Root>
                            )}
                        </For>
                    </Fieldset.Content>
                </CheckboxGroup>
            </Fieldset.Root>
        </Field>
    );
};

export default CheckboxView;
